import {isEmpty} from "../../common/utils/StringUtils";
import {postSync} from "../../common/utils/http";
import {numStrFormat2} from "../../common/utils/NumberUtils";
import BigNumber from "bignumber.js";
import {dropByCacheKey} from "react-router-cache-route";
import moment from "moment";
import * as cookie from "react-cookies";
import localeCN from 'antd/es/date-picker/locale/zh_CN';
import paginationCN from 'rc-pagination/lib/locale/zh_CN';
import {isCanNotEmptyTip, lengthMustBeGreaterThan} from "../../constant/js/formItemNameLabel/en_US/common";
import {formMomentFormat, getExportColumnsData} from "../../common/utils/ObjectUtils";
import {aisinoInfoModal} from "../../common/modal/AisinoModalMethod";
import ReactDOM from "react-dom";
import {Spin} from "antd";
import React from "react";

//Cookie存储常量
export const LOGIN = "login";
export const TIN = "local-tin";
export const USER_ID = "local-userId";
export const BUSINESS_NAME = "local-businessName";
export const BRANCH_ID = "local-branchId";
export const BRN_NIN = "local-brnNin";
export const LEGAL_NAME = "local-legalName";
export const LOCATION_ID = "local-locationID";
export const TAXPAYER_ID = "local-taxpayerId";
//下拉框默认值
export const PLEASE_SELECT = "please select";
//举报地址
export const COMPLIANCE_URL="complianceUrl";
//多语言
export const LANGUAGE="cookie_language";
export const LANGUAGE_EN="en_US";
export const LANGUAGE_ZH="zh_CN";
export const DEFAULT_LANGUAGE=LANGUAGE_EN;
export let currentCurrency = "MYR";
export let exportLimit=10000;
export let cancelSubmissionInterval=0;
export let buttonIdArr=[];
export let selectedTinArr=[];
export let cancelRejectLimit=72;
export let invoiceSubmissionInterval=0;
export let perBatchSubmissionNumber=0;
export let maxInquiryDays=30;
export let backupUploadedFileDeletePeriod=30;
export let infoModalVisible = false;

export function setCancelRejectLimit(val){
    if(val){
        cancelRejectLimit = val;
    }
}
export function getCancelRejectLimit(){
    return cancelRejectLimit
}
export function setCancelSubmissionInterval(val){
    cancelSubmissionInterval = val
}
export function getCancelSubmissionInterval(){
    return cancelSubmissionInterval;
}
export function setInvoiceSubmissionInterval(val){
    invoiceSubmissionInterval = val
}
export function getInvoiceSubmissionInterval(){
    return invoiceSubmissionInterval;
}
export function setPerBatchSubmissionNumber(val){
    perBatchSubmissionNumber = val
}
export function getPerBatchSubmissionNumber(){
    return perBatchSubmissionNumber;
}

export function setExportLimit(exportLimitNum){
    if(exportLimitNum){
        exportLimit = exportLimitNum
    }
}
export function getExportLimit(){
    return exportLimit;
}

export function getMaxInquiryDays(){
    return maxInquiryDays;
}
export function setMaxInquiryDays(paramsMaxInquiryDays){
    if(paramsMaxInquiryDays){
        maxInquiryDays = paramsMaxInquiryDays;
    }
}


export function getBackupUploadedFileDeletePeriod(){
    return backupUploadedFileDeletePeriod;
}
export function setBackupUploadedFileDeletePeriod(period){
    if(period){
        backupUploadedFileDeletePeriod = period;
    }
}


export function getCurrentCurrency(){
    return currentCurrency;
}
export function setCurrentCurrencyFun(currency){
    currentCurrency=currency;
}

export function setButtonIdFun(menuIdList){
    buttonIdArr=menuIdList;
}
export function buttonIsHidden(menuId) {
    if(buttonIdArr==='ALL'){
        return false;
    }
    // 使用includes()方法检查menuId是否在buttonIdArr数组中
    return !buttonIdArr.includes(menuId);
}

export function setSelectedTinListFun(selectedTinList){
    selectedTinArr=selectedTinList;
}
export function getSelectedTin(){
    return selectedTinArr;
}

export function setInfoModalVisible(flag){
    infoModalVisible = flag;
}
export function isInfoModalVisible(){
    return infoModalVisible;
}

export function numberFormatNew(str){
    if(isEmpty(str)||isNaN(str.replace(/,/g, ''))){
        return str
    }else{
        str=str.replace(/,/g,'');
        return new BigNumber(str).dp(8,BigNumber.ROUND_DOWN).toFormat();
    }
}
export function numberFormatPlaces(str,places){

    if(isEmpty(str)){
        return str;
    }
    str=str+'';
    if(isNaN(str.replace(/,/g, ''))){
        return str;
    } else{
        str=str.replace(/,/g,'');
        let displayDecimalSetting = sessionStorage.getItem("displayDecimalSetting");
        if(!isEmpty(displayDecimalSetting)){
            places = parseInt(displayDecimalSetting);
        }
        if(isEmpty(places)){
            places = 2;
        }
        return new BigNumber(str).dp(places, BigNumber.ROUND_DOWN).toFormat(places);
    }
}

export function numberFormatPlacesUnitPrice(str,places){

    if(isEmpty(str)){
        return str;
    }
    str=str+'';
    if(isNaN(str.replace(/,/g, ''))){
        return str;
    } else{
        str=str.replace(/,/g,'');
        let displayDecimalSetting = sessionStorage.getItem("unitPriceDisplayDecimalSetting");
        if(!isEmpty(displayDecimalSetting)){
            places = parseInt(displayDecimalSetting);
        }
        if(isEmpty(places)){
            places = 4;
        }
        return new BigNumber(str).dp(places, BigNumber.ROUND_DOWN).toFormat(places);
    }
}
export function getLanguage(){
    let language=cookie.load(LANGUAGE);
    if(language===undefined || language==='undefined'){
        language=DEFAULT_LANGUAGE;
    }
    return language;
}
export const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
export function getDatePickerLanguage(){
    const lan = getLanguage();
    if(lan===LANGUAGE_ZH){
        return localeCN;
    }
    return null;
}
export function getPaginationLanguage(){
    const lan = getLanguage();
    if(lan===LANGUAGE_ZH){
        return paginationCN;
    }
    return null;
}
export function arrayToJson(treeArray){
    let r = [];
    let tmpMap ={};
    for (let i=0, l=treeArray.length; i<l; i++) {
        // 以每条数据的id作为obj的key值，数据作为value值存入到一个临时对象里面
        tmpMap[treeArray[i]["id"]]= treeArray[i];
    }
    for (let i=0, l=treeArray.length; i<l; i++) {
        let key=tmpMap[treeArray[i]["parentId"]];

        //循环每一条数据的pid，假如这个临时对象有这个key值，就代表这个key对应的数据有children，需要Push进去
        if (key) {
            if (!key["children"]){
                key["children"] = [];
                key["children"].push(treeArray[i]);
            }else{
                key["children"].push(treeArray[i]);
            }
        } else {
            //如果没有这个Key值，那就代表没有父级,直接放在最外层
            r.push(treeArray[i]);
        }
    }
    return r;
}
export function sonsTree(arr,id){
    let temp = [],lev=0;
    let forFn = function(arr, id,lev){
        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.parentId==id) {
                item.lev=lev;
                temp.push(item);
                forFn(arr,item.id,lev+1);
            }
        }
    };
    forFn(arr, id,lev);
    return temp;
}
//checkbox多选数组转字符串
export function arrayToObject(arr) {
    let temp="";
    if(arr.constructor===Array){
        if(arr.length>0){
            for(let i = 0; i < arr.length; i++){
                temp += arr[i]+",";
            }
            temp = temp.substring(0,temp.length-1);
        }
    }
    else{
        temp=arr;
    }
    return temp;
}
export  function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
export function dateDiff(startTime, endTime) {
    let diff = "";
    if (isEmpty(startTime)) {
        return "";
    }
    if (isEmpty(endTime)) {
        return "";
    }
    startTime = Date.parse(startTime.replace(/-/g,"/"));
    endTime = Date.parse(endTime.replace(/-/g,"/"));
    //结束时间小于开始时间返回空
    if (new Date(endTime).getTime() < new Date(startTime).getTime()) {
        return "";
    }
    diff = new Date(endTime).getTime() - new Date(startTime).getTime();
    //计算出相差天数
    let days = Math.floor(diff / (24 * 3600 * 1000));
    //计算出小时数
    let leave1 = diff % (24 * 3600 * 1000);   //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000));
    if (hours <= 9) {
        hours = '0' + hours;
    }
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000);       //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000));
    if (minutes <= 9) {
        minutes = '0' + minutes;
    }
    let waitTimeStr = "";
    if (parseInt(days) == 0) {
        waitTimeStr = hours + ":" + minutes;
    } else {
        waitTimeStr = days + "days," + hours + ":" + minutes;
    }
    return waitTimeStr;
}
export function validateMessages(){
    return{
        required: "${label}"+commonLan.isRequiredTip.label,
        string:{
            max:"${label}"+ commonLan.lengthMustBeLessThan.label +"${max}",
            min:"${label}"+ commonLan.lengthMustBeGreaterThan.label +"${min}"
        },
        types:{
            email:"${label}"+ commonLan.notValidEmail.label
        },
        whitespace:"${label}"+commonLan.isCanNotEmptyTip.label
    }
}
export function validateStrLength(value, maxLength){
    let totalLength = 0;
    if(isEmpty(value)){
        return Promise.resolve();
    }
    /* 计算utf-8编码情况下的字符串长度 */
    for ( let i = 0 ; i < value .length ; i++){
        if ( value .charCodeAt (i ) <= parseInt ("0x7F") ){
            totalLength += 1;
        }
        else if (value .charCodeAt (i ) <= parseInt ("0x7FF")){
            totalLength += 2;
        }
        else if (value .charCodeAt (i ) <= parseInt("0xFFFF" )){
            totalLength += 3;
        }
        else if (value .charCodeAt (i ) <= parseInt("0x1FFFFF" )){
            totalLength += 4;
        }
        else if (value .charCodeAt (i ) <= parseInt("0x3FFFFFF" )){
            totalLength += 5;
        }
        else{
            totalLength += 6;
        }
    }
    if (totalLength>maxLength) {
        return Promise.reject("Please enter no more than "+maxLength+" characters.");
    }
    return Promise.resolve();
}
//文本格式化数字函数（可去除非数字内容）
//返回含有千分符的数字字符串
//可输入负数
export function numFormatterMinus(value,intLimit,floatLimit){
    value=value+"";
    if(value.length>0 && value.indexOf("-") === 0){
        return "-"+numFormatter(value,intLimit,floatLimit);
    }
    let val = numFormatter(value,intLimit,floatLimit);
    return val.replace(/,/g,'');
}
export function numFormatterMinusWithSymbol(value,intLimit,floatLimit){
    value=value+"";
    if(value.length>0 && value.indexOf("-") === 0){
        return "-"+numFormatter(value,intLimit,floatLimit);
    }
    let val = numFormatter(value,intLimit,floatLimit);
    return val;
}
//文本格式化数字函数（可去除非数字内容）
//返回含有千分符的数字字符串
export function numFormatter(value,intLimit,floatLimit){
    //整数位长度
    if(isEmpty(intLimit)){
        intLimit=12
    }
    //小数位长度
    if(isEmpty(floatLimit)){
        floatLimit=8
    }
    value=(value+"").replace(/,|-| /g,"");
    if( typeof value==='string'&&isNaN(Number(value))){
        value=value.replace(/[^\d.]/g,"").replace(/^\./g,"")
            .replace(/\.{2,}/g,".").replace(".","$#$")
            .replace(/\./g,"").replace("$#$",".")
            .replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            });
    }
    value=(value+"");
    let havePoint=false;
    if(value.indexOf(".")>0){
        havePoint=true;
    }
    let valueArr=value.split('.');
    let intPart=valueArr[0];
    if(intPart.length>1&&intPart.charAt(0)==='0'){
        intPart=intPart.substr(1);
    }
    let floatPart=valueArr[1];
    if(intPart&&intPart.length>intLimit){
        intPart=intPart.substr(0,intLimit)
    }
    if(floatPart&&floatPart.length>floatLimit){
        floatPart=floatPart.substr(0,floatLimit)
    }
    if(intPart&&floatPart){
        value=(intPart+'.'+floatPart).replace(/\d+/, function(n){ // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                return $1+",";
            });
        });
    }else if(intPart){
        if(havePoint&&floatLimit!==0){
            intPart=intPart+".";
        }
        value=intPart.replace(/\d+/, function(n){ // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                return $1+",";
            })
        });
    }
    return value
}
const rejectReason = [{id: '1', text: 'Similar Detail Found'},
    {id: '2', text: 'Inadequate Information Given in Application'},
    {id: '3', text: 'Unknown Location'},{id: '4', text: 'Other (Please Specify)'}];
export function getRejectReason(reasonCode) {
    let reasons = "";
    let index;
    for (let i = 0; i < reasonCode.length; i++) {
        index = i + 1;
        for (let j = 0; j < rejectReason.length; j++) {
            if (!isEmpty(reasonCode[i]) && reasonCode[i] == rejectReason[j].id) {
                reasons += rejectReason[j].id + ". " + rejectReason[j].text + " ";
            }
        }
    }
    return reasons;
}
export function getDateFormat() {
    let dateFormatter = '',timeFormatter='';
    postSync('aisino/df/getDataFormat',{},false)
        .then(data =>{
            // //console.log("getDateFormat data",data);
            if(!isEmpty(data)){
                dateFormatter = data.dateFormat;
                timeFormatter = data.timeFormat;
                sessionStorage.setItem("dateFormatter",dateFormatter.replace('dd','DD'));
                sessionStorage.setItem("timeFormatter",timeFormatter.replace('yyyy','YYYY').replace('dd','DD').replace('HH24','HH').replace('mi','mm'));
            }
        });
}
let currencyRate ='1';
let initCurrency = isEmpty(cookie.load("initCurrency"))?"USD":cookie.load("initCurrency");
// console.log("common initCurrency=",initCurrency);
/**币种转换：先转为本位币UGX，再用UGX去转其他币种
 * currency:商品的币种
 * changeCurrency:要转换的币种
 * unitPrice:当前币种的商品单价
 * 币种转换：先转为本位币UGX，再用UGX去转其他币种
 * issuedDate:变更增加开票时间
 **/
export async function currencyChange(currency,changeCurrency,unitPrice,issuedDate,invoiceKind,invoiceIndustryCode) {
    // //console.log("currency="+currency+",changeCurrency="+changeCurrency+",unitPrice="+unitPrice);
    let afterChangeUnitPrice = 0;
    if(!isEmpty(unitPrice)){
        if(currency != initCurrency){
            await getCurrencyRate(currency,issuedDate,invoiceKind,invoiceIndustryCode);
            let beforeCurrencyRate = currencyRate;
            // //console.log("beforeCurrencyRate="+beforeCurrencyRate);
            //计算出UGX本位币的价格
            let ugxUnitPrice = BigNumber(unitPrice.replace(/,/g,'')).times(new BigNumber(beforeCurrencyRate));
            //console.log("ugxUnitPrice="+ugxUnitPrice);
            await getCurrencyRate(changeCurrency,issuedDate,invoiceKind,invoiceIndustryCode);
            let changeCurrencyRate = currencyRate;
            //console.log("changeCurrencyRate="+changeCurrencyRate);
            afterChangeUnitPrice = BigNumber(ugxUnitPrice).div(new BigNumber(changeCurrencyRate));
            afterChangeUnitPrice = numStrFormat2(afterChangeUnitPrice.dp(8,BigNumber.ROUND_DOWN).toFormat(),8);
            //console.log("afterChangeUnitPrice",afterChangeUnitPrice);
        }
        else{
            await getCurrencyRate(changeCurrency,issuedDate,invoiceKind,invoiceIndustryCode);
            let changeCurrencyRate = currencyRate;
            //console.log("changeCurrencyRate="+changeCurrencyRate);
            afterChangeUnitPrice = BigNumber(unitPrice.replace(/,/g,'')).div(new BigNumber(changeCurrencyRate));
            afterChangeUnitPrice = numStrFormat2(afterChangeUnitPrice.dp(8,BigNumber.ROUND_DOWN).toFormat(),8);
            //console.log("afterChangeUnitPrice",afterChangeUnitPrice);
        }
    }
    return afterChangeUnitPrice;
}
export async function getCurrencyRate(currency,issuedDate,invoiceKind,invoiceIndustryCode){
    await postSync('/invoice/aisino/fiscaldocument/getCurrencyRate',{
        currency:currency,
        issuedDate:issuedDate,
        invoiceKind:invoiceKind,
        invoiceIndustryCode:invoiceIndustryCode,
    },false)
        .then(data=>{
            currencyRate = data;
            // //console.log("----------2--------currencyRate",data);
            return currencyRate;
        });
}
//清缓存 that页面对象  clearLength清除页数
export function clearUrlHistory(that,clearLength){
    let pathname =that.props.history.location.pathname;
    for(let i=1;i<=clearLength;i++){
        dropByCacheKey(pathname);
        pathname=pathname.substr(0,pathname.lastIndexOf('/'))
    }
}
//***查询域  开始时间与结束时间关联事件   开始***
export function disabledStartDate(current,that,index,maxInterval,showTime){
    if(!index){
        index="";
    }
    let currentDate;
    let endDate;
    if(showTime){
        currentDate = current;
        endDate=that.state["_endDate"+index]
    }else{
        currentDate = current.format("YYYY-MM-DD");
        endDate=that.state["_endDate"+index]?that.state["_endDate"+index].format("YYYY-MM-DD"):that.state["_endDate"+index];
    }
    if(that.state["_endDate"+index]){
        if(maxInterval){
            return currentDate>endDate|| moment(currentDate)<moment(endDate).add(-maxInterval,'days');
        }else{
            return currentDate>endDate;
        }
    }
    return false ;
}
export function disabledEndDate(current,that,index,maxInterval,showTime){
    if(!index){
        index="";
    }
    let currentDate;
    let startDate;
    if(showTime){
        currentDate = current;
        startDate=that.state["_startDate"+index]
    }else{
        currentDate = current.format("YYYY-MM-DD");
        startDate=that.state["_startDate"+index]?that.state["_startDate"+index].format("YYYY-MM-DD"):that.state["_startDate"+index];
    }
    if(that.state["_startDate"+index]){
        if(maxInterval){
            return currentDate<startDate|| moment(currentDate)>moment(startDate).add(maxInterval,'days');
        }else{
            return currentDate<startDate;
        }
    }
    return false;
}
export function startDateChange(date,dateString,that,index){
    if(!index){
        index="";
    }
    if(date){
        that.state["_startDate"+index]=date;
    }else{
        that.state["_startDate"+index]="";
    }

}
export function endDateChange(date,dateString,that,index){
    if(!index){
        index="";
    }
    if(date){
        that.state["_endDate"+index]=date;
    }else{
        that.state["_endDate"+index]="";
    }
}

export function disabledStartDateForMonth(current,that,index,maxInterval,showTime){
    if(!index){
        index="";
    }
    let currentDate;
    let endDate;
    if(showTime){
        currentDate = current;
        endDate=that.state["_endDate"+index]
    }else{
        currentDate = current.startOf('month');
        endDate=that.state["_endDate"+index]?that.state["_endDate"+index].startOf('month'):that.state["_endDate"+index];
    }
    if(endDate){
        if(maxInterval){
            return currentDate>endDate|| currentDate<moment(endDate).add(-maxInterval,'months');
        }else{
            return currentDate>endDate;
        }
    }
    return false ;
}
export function disabledEndDateForMonth(current,that,index,maxInterval,showTime){
    if(!index){
        index="";
    }
    let currentDate;
    let startDate;
    if(showTime){
        currentDate = current;
        startDate=that.state["_startDate"+index]
    }else{
        currentDate = current.startOf('month');
        startDate=that.state["_startDate"+index]?that.state["_startDate"+index].startOf('month'):that.state["_startDate"+index];
    }
    if(startDate){
        if(maxInterval){
            return currentDate<startDate|| currentDate>moment(startDate).add(maxInterval,'months');
        }else{
            return currentDate<startDate;
        }
    }
    return false;
}
//***查询域  开始时间与结束时间关联事件   结束***
export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
//事件阻止冒泡兼容IE的方法
export function stopBubble(e) {
    //如果提供了事件对象，则这是一个非IE浏览器
    if ( e && e.stopPropagation )
    //因此它支持W3C的stopPropagation()方法
        e.stopPropagation();
    else
    //否则，我们需要使用IE的方式来取消事件冒泡
        window.event.cancelBubble = true;
}

/**
 * description: 校验商品行的状态及单位与商品信息是否一致
 * @author yaoran
 * @date 2020/10/27 17:32
 * @param goodsList 商品行List 必填
 * @param tin 非必填，可为空，为空为当前登录的tin
 * @return 返回空表示校验通过，不为空表示校验失败
 **/
let goodsInfo ="";
let otherUnitFlag = false;
export async function checkGoodsListIsCorrect(goodsList,tin){
    let goodsName = "";
    if(!isEmpty(goodsList)){
        for(let i=0;i<goodsList.length;i++){
            await getGoodsInfo(goodsList[i].itemName,goodsList[i].itemCode,tin);
            await validateGoodsOtherUnit(goodsList[i].itemCode,tin,goodsList[i].unit);
            if(!isEmpty(goodsInfo)){
                //console.log("goodsInfo",goodsInfo);
                //被删除或者被禁用
                if(goodsInfo.deleteFlag =='1' || goodsInfo.statusCode == '102'){
                    goodsName += goodsInfo.goodsName +',';
                }
                else{
                    //有piece单位，判断是否与piece单位或包单位是否一致，并且是否是other单位的其中之一
                    if(goodsInfo.havePieceUnit == '101'){
                        if( goodsList[i].unit != goodsInfo.measureUnit && goodsList[i].unit != goodsInfo.pieceMeasureUnit && !otherUnitFlag ){
                            goodsName += goodsInfo.goodsName + ',';
                        }
                    }
                    else{
                        //无piece单位
                        if(goodsList[i].unit != goodsInfo.measureUnit  ){
                            goodsName += goodsInfo.goodsName + ',';
                        }
                    }
                }
            }
            else{
                goodsName += goodsList[i].itemName + ',';
            }
        }
        goodsName = goodsName.substring(0,goodsName.length-1);
    }
    //console.log(goodsName);
    return goodsName;
}
//根据商品code,查询商品信息
export async function getGoodsInfo(goodsName,goodsCode,tin) {
    await postSync("/stock/aisino/goodsStockIn/getGoodsUnitInfo",{
        "goodsCode": goodsCode,
        "tin":tin,
    },false)
        .then(data=>{
            // //console.log("goodsInfo",data);
            if(data != null){
                data.goodsName = goodsName;
                goodsInfo = data;
            }
            else{
                goodsInfo = "";
            }
            return goodsInfo;
        });
}
export async function validateGoodsOtherUnit(goodsCode,tin,otherUnit) {
    await postSync("/stock/aisino/goodsStockIn/getGoodsOtherUnitInfo",{
        "goodsCode": goodsCode,
        "tin":tin,
        "otherUnit":otherUnit,
    },false)
        .then(data=>{
            if(data != null && data.deleteFlag=='0'){
                otherUnitFlag = true;
            }
            else{
                otherUnitFlag = false;
            }
            //console.log("otherUnitFlag",otherUnitFlag);
            return otherUnitFlag;
        });
}
/**
 * description:  根据业务主键ID校验当前流程是否属于当前登录人，返回true属于当前登录人，返回false不属于当前登录人
 * @author yaoran
 * @date 2023/09/22 13:13
 * @param null
 * @return
**/
export async function checkIsUserParticipateTask(businessKey){
    let checkFlag = false;
    await postSync('/workflow/aisino/process/checkIsUserParticipateTask',{
        businessKey:businessKey,
    },false)
    .then(data=>{
        checkFlag = data;
    });
    return checkFlag;
}

export function setSearchStartAndEndDate(that,startLabelName,endLabelName,index,form,unitOfTime) {
    let searchForm = "";
    if (form) {
        searchForm = form;
    } else {
        searchForm = that.refs.searchForm.refs.form;
    }
    if (!searchForm) {
        return;
    }
    if (!unitOfTime) {
        unitOfTime = "month";
    }
    //月初
    let startDate = moment().startOf(unitOfTime);
    //月末
    let endDate = moment();
    let p = {};
    p[startLabelName] = startDate;
    p[endLabelName] = endDate;
    startDateChange(startDate, "", that, index);
    endDateChange(endDate, "", that, index);
    searchForm.setFieldsValue(p);
}

export function exportLargeFile(searchParams,columns,type){
    const columnsData =getExportColumnsData(columns);
    var params={
        exportLargeFileType:type,
        searchParams:formMomentFormat(searchParams),
        columns:columnsData.columns,
        dictionaryCodes:columnsData.dictionaryCodes
    }
    postSync("aos/print/largeFileExport",params).then(res=> {
        if(res){
            if(res.includes("fail:")){
                aisinoInfoModal(res.substr("fail:".length));
                return;
            }
            aisinoInfoModal(commonLan.downloadTaskInitiated)
        }
    })
}


export function showLoading(){
    const loadingDiv = document.getElementById('loading');
    if(isEmpty(loadingDiv)){
        let dom = document.createElement('div');
        dom.setAttribute('id', 'loading');
        document.body.appendChild(dom);
        ReactDOM.render(<Spin wrapperClassName='react-loadings' size="large" tip={commonLan.loading}></Spin>, dom);
    }
}

export function hideLoading(){
    const loadingDiv = document.getElementById('loading');
    if(loadingDiv){
        document.body.removeChild(document.getElementById('loading'));
    }
}
